/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Metaonia Content Service API
 * The Content Service provides the education and training content for Metaonia.
It serves three types of content:

1. **Articles** -- Evidence-based education library curated by menopause specialists.
   Filterable by category and symptom type. Available to all users.

2. **Micro-interventions** -- Short (approximately 2-minute) exercises tied to specific
   symptoms. Designed for use during the workday when a symptom occurs.

3. **Training modules** -- Scenario-based manager training with branching dialogue
   trees. Six workplace scenarios covering accommodation conversations, check-ins,
   and team support. Completion tracked and visible to HR.

## Privacy

This service contains NO Protected Health Information (PHI). It is safe to cache
content responses (articles, interventions, training modules) per the Cache-Control
headers in each response.

## Cacheability

| Resource | Cache-Control | Rationale |
|----------|--------------|-----------|
| Articles | `public, max-age=3600` (1 hour) | Content changes infrequently |
| Micro-interventions | `public, max-age=3600` (1 hour) | Static exercise instructions |
| Training modules | `public, max-age=86400` (24 hours) | Very stable content |
| Training progress | `no-store` | User-specific, changes on completion |

 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { customInstance } from '../../../axios-instance';
/**
 * Returns the list of manager training modules. Uses offset-based pagination
since this is a small, bounded list (approximately 6 modules).

Available to users with `manager`, `hr_admin`, or `org_admin` roles.

 * @summary List manager training modules
 */
export const listTrainingModules = (params, options, signal) => {
    return customInstance({ url: `/content/training-modules`, method: 'GET',
        params, signal
    }, options);
};
export const getListTrainingModulesInfiniteQueryKey = (params) => {
    return [
        'infinite', `/content/training-modules`, ...(params ? [params] : [])
    ];
};
export const getListTrainingModulesQueryKey = (params) => {
    return [
        `/content/training-modules`, ...(params ? [params] : [])
    ];
};
export const getListTrainingModulesInfiniteQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListTrainingModulesInfiniteQueryKey(params);
    const queryFn = ({ signal }) => listTrainingModules(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary List manager training modules
 */
export function useListTrainingModulesInfinite(params, options, queryClient) {
    const queryOptions = getListTrainingModulesInfiniteQueryOptions(params, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getListTrainingModulesQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListTrainingModulesQueryKey(params);
    const queryFn = ({ signal }) => listTrainingModules(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary List manager training modules
 */
export function useListTrainingModules(params, options, queryClient) {
    const queryOptions = getListTrainingModulesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getListTrainingModulesSuspenseQueryOptions = (params, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListTrainingModulesQueryKey(params);
    const queryFn = ({ signal }) => listTrainingModules(params, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary List manager training modules
 */
export function useListTrainingModulesSuspense(params, options, queryClient) {
    const queryOptions = getListTrainingModulesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Returns a training module with its full scenario data (branching dialogue tree).
The scenario tree contains nodes with prompts, response options, and consequences.

Available to users with `manager`, `hr_admin`, or `org_admin` roles.
Supports ETag caching.

 * @summary Get a single training module with scenarios
 */
export const getTrainingModule = (id, options, signal) => {
    return customInstance({ url: `/content/training-modules/${id}`, method: 'GET', signal
    }, options);
};
export const getGetTrainingModuleInfiniteQueryKey = (id) => {
    return [
        'infinite', `/content/training-modules/${id}`
    ];
};
export const getGetTrainingModuleQueryKey = (id) => {
    return [
        `/content/training-modules/${id}`
    ];
};
export const getGetTrainingModuleInfiniteQueryOptions = (id, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingModuleInfiniteQueryKey(id);
    const queryFn = ({ signal }) => getTrainingModule(id, requestOptions, signal);
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
/**
 * @summary Get a single training module with scenarios
 */
export function useGetTrainingModuleInfinite(id, options, queryClient) {
    const queryOptions = getGetTrainingModuleInfiniteQueryOptions(id, options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetTrainingModuleQueryOptions = (id, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingModuleQueryKey(id);
    const queryFn = ({ signal }) => getTrainingModule(id, requestOptions, signal);
    return { queryKey, queryFn, enabled: !!(id), ...queryOptions };
};
/**
 * @summary Get a single training module with scenarios
 */
export function useGetTrainingModule(id, options, queryClient) {
    const queryOptions = getGetTrainingModuleQueryOptions(id, options);
    const query = useQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetTrainingModuleSuspenseQueryOptions = (id, options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingModuleQueryKey(id);
    const queryFn = ({ signal }) => getTrainingModule(id, requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get a single training module with scenarios
 */
export function useGetTrainingModuleSuspense(id, options, queryClient) {
    const queryOptions = getGetTrainingModuleSuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * Records that the authenticated user has completed a training module.
Includes the scenario choices and outcomes (score) for analytics.

Duplicate completions for the same user and module return `409 Conflict`.
Requires `Idempotency-Key` header for safe retries.

**Audit**: Logs `training.complete` to the audit trail (not PHI).

 * @summary Mark a training module as complete
 */
export const completeTrainingModule = (id, trainingCompletionRequest, options, signal) => {
    return customInstance({ url: `/content/training-modules/${id}/complete`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: trainingCompletionRequest, signal
    }, options);
};
export const getCompleteTrainingModuleMutationOptions = (options) => {
    const mutationKey = ['completeTrainingModule'];
    const { mutation: mutationOptions, request: requestOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, }, request: undefined };
    const mutationFn = (props) => {
        const { id, data } = props ?? {};
        return completeTrainingModule(id, data, requestOptions);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary Mark a training module as complete
*/
export const useCompleteTrainingModule = (options, queryClient) => {
    const mutationOptions = getCompleteTrainingModuleMutationOptions(options);
    return useMutation(mutationOptions, queryClient);
};
/**
* Returns the authenticated user's training progress across all modules.
Shows which modules are completed, overall completion percentage,
and time spent.

Available to users with `manager`, `hr_admin`, or `org_admin` roles.
Not cacheable (user-specific, changes on completion).

* @summary Get user's training progress
*/
export const getTrainingProgress = (options, signal) => {
    return customInstance({ url: `/content/training-progress`, method: 'GET', signal
    }, options);
};
export const getGetTrainingProgressInfiniteQueryKey = () => {
    return [
        'infinite', `/content/training-progress`
    ];
};
export const getGetTrainingProgressQueryKey = () => {
    return [
        `/content/training-progress`
    ];
};
export const getGetTrainingProgressInfiniteQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingProgressInfiniteQueryKey();
    const queryFn = ({ signal }) => getTrainingProgress(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get user's training progress
 */
export function useGetTrainingProgressInfinite(options, queryClient) {
    const queryOptions = getGetTrainingProgressInfiniteQueryOptions(options);
    const query = useInfiniteQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetTrainingProgressQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingProgressQueryKey();
    const queryFn = ({ signal }) => getTrainingProgress(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get user's training progress
 */
export function useGetTrainingProgress(options, queryClient) {
    const queryOptions = getGetTrainingProgressQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getGetTrainingProgressSuspenseQueryOptions = (options) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrainingProgressQueryKey();
    const queryFn = ({ signal }) => getTrainingProgress(requestOptions, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary Get user's training progress
 */
export function useGetTrainingProgressSuspense(options, queryClient) {
    const queryOptions = getGetTrainingProgressSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    query.queryKey = queryOptions.queryKey;
    return query;
}
//# sourceMappingURL=training.js.map